/* globals process */

export const BASE_URL = process.env.BASE_URL || "";

export const DEBUG = process.env.NODE_ENV === "development";

export const DEFAULT_PAGESIZE = 25;
export const DEFAULT_PAGESIZE_S = 5;
export const TASK_LIST = [
    ["INBOX", "My research items"],
    ["QUEUE", "Not assigned"],
    ["ALLOPEN", "All open research items"],
    ["DONE", "Auto-Completed"],
];
export const DEFAULT_TASK_TYPE = TASK_LIST[0][0];

const CLIENTS = {
    EXAMPLECORP: "examplecorp",
    FFM: "ffm",
    FFMBUS: "ffmbus",
    KITCHENSINK: "kitchensink",
    SFCU: "sfcu",
    SHEPHERDDEMO: "shepherddemo",
};

export const NARRATIVE_EVENT_TYPES = {
    RESULT_SELECTED: "ResultSelected",
    DOCUMENT_UPLOADED: "DocumentUploaded",
    ENTITY_UPDATED: "EntityUpdated",
    RELATIONS_UPDATED: "RelationsUpdated",
    COMMENT_POSTED: "CommentPosted",
    USER_ASSIGNED: "UserAssigned",
    USER_UNASSIGNED: "UserUnassigned",
    TASK_DISPOSITIONED: "TaskDispositioned",
    TASK_REVIEWED: "TaskReviewed",
    TASK_PROCESSED_SUMMARY: "TaskProcessedSummary",
};

export const SHOULD_SHOW_EXTENDED_ENTITY_SCHEMA = [
    CLIENTS.EXAMPLECORP,
    CLIENTS.SHEPHERDDEMO,
].includes(window.CLIENT);

export const PERMISSION_DENIED_PATH = "/permission-denied/";
